/**
 * @typedef {Object} SelectedOption
 * @property {string} selectedOptions[].name - The name of the option.
 * @property {string} selectedOptions[].value - The value of the option.
 */

/**
 * @typedef {Object} SelectedOption
 * @property {string} selectedOptions[].name - The name of the option.
 * @property {string} selectedOptions[].value - The value of the option.
 */

/**
 * @typedef {Object} ProductVariant
 * @property {Object} metafield - Metafield information.
 * @property {string} metafield.value - The value of the metafield.
 * @property {string} id - The unique identifier of the product variant.
 * @property {Array<SelectedOption>} selectedOptions - An array of selected options.
 * @property {Object} price - The price information.
 * @property {string} price.amount - The amount of the price.
 */

/**
 * @typedef {Object} ProductVariant
 * @property {Object} metafield - Metafield information.
 * @property {string} metafield.value - The value of the metafield.
 * @property {string} id - The unique identifier of the product variant.
 * @property {Array<SelectedOption>} selectedOptions - An array of selected options.
 * @property {Object} price - The price information.
 * @property {string} price.amount - The amount of the price.
 * @property {boolean} availableForSale - The amount of the price.
 */

/**
 * @typedef {Object} FeaturedImage
 * @property {string} src - The source URL of the featured image.
 * @property {string} id
 */

/**
 * @typedef {Object} Product
 * @property {string} id - The unique identifier of the product.
 * @property {string} title - The title of the product.
 * @property {FeaturedImage} featuredImage - The featured image of the product.
 * @property {Array<Object>} options - An array of options available for the product.
 * @property {string} options[].name - The name of the option.
 * @property {Object} variants - Variants of the product.
 * @property {Array<ProductVariant>} variants.nodes - An array of variant nodes.
 * @property {Object} variants.nodes[].metafield - Metafield information of the variant.
 * @property {string} variants.nodes[].metafield.value - The value of the metafield.
 * @property {string} variants.nodes[].id - The unique identifier of the variant.
 * @property {Array<Object>} variants.nodes[].selectedOptions - An array of selected options for the variant.
 * @property {string} variants.nodes[].selectedOptions[].name - The name of the option.
 * @property {string} variants.nodes[].selectedOptions[].value - The value of the option.
 * @property {Object} variants.nodes[].price - The price information of the variant.
 * @property {string} variants.nodes[].price.amount - The amount of the price.
 * @property {string} vendor - The vendor of the product.
 */

class BtCompareUtil {
  // static bubbleHtmlClass = ".compare-count-bubble";
  static loadedContent = false;
  static compareProducts = new Map();
  static currentProductVariants = new Map();

  // Initializes the utility class
  static init() {
    BtCompareUtil.updateCompareBubble(true);
    // BtCompareUtil.setCompareArray(['7982162510036', '7931786494164','7457125433556','7499320230100'])
    // BtCompareUtil.setCompareArray(['7982162510036', '7931786494164','7457125433556']);
    // BtCompareUtil.setCompareArray(['7982162510036', '7931786494164']);
    // BtCompareUtil.setCompareArray(['7931786494164']);
    // BtCompareUtil.setCompareArray(['7457125433556'])

    if (BtCompareUtil.getCompareArray()) {
      for (const productId of BtCompareUtil.getCompareArray()) {
        if (this.compareProducts.has(productId)) {
          continue;
        }

        this.compareProducts.set(productId, new Set());
      }
      this.renderProducts();
    }
  }

  // Sets the array of products for comparison in storage
  static setCompareArray(compareArray) {
    localStorage.setItem(
      `rentoza-compare_products`,
      typeof compareArray === "object"
        ? JSON.stringify(compareArray)
        : compareArray
    );
  }

  // Retrieves the array of products for comparison from storage

  /**
   * Description placeholder
   * @date 20/02/2024 - 17:10:34
   *
   * @static
   * @returns {Array}
   */
  static getCompareArray() {
    const value = localStorage.getItem(`rentoza-compare_products`);
    return JSON.parse(value) || [];
  }

  // Toggles a product's presence in the comparison array
  static toggleProductIntoCompare(productId) {
    let currentProducts = this.getCompareArray();

    // if (!currentProducts) {
    //     currentProducts = [];
    // }

    const index = currentProducts.indexOf(productId);

    if (currentProducts.includes(productId)) {
      return;
    }

    if (index !== -1) {
      //TODO - SHOW MESSAGE FOR ITEM ALREADY BEING IN THE ARRAY
      return;
    }

    if (currentProducts.length == 2) {
      //TODO - SHOW MESSAGE FOR WHEN COMPARE ARRAY IS FULL
      return;
    }

    currentProducts.push(productId);
    this.setCompareArray(currentProducts);

    this.renderProducts();
    // const popupModalToggler =document.getElementById('button[data-modal-toggle="popup-modal"]');
    // if (popupModalToggler) {
    //     popupModalToggler.click();
    //     // popupModal.classList.remove()
    // }
    //this.updateCompareBubble();
    // this.toggleEmptyWarning(document.querySelector("compare-popup"));
  }

  // Removes a product from the comparison array
  static removeCompareProduct(productId) {
    const currentProducts = this.getCompareArray();
    const productToDelete = this.compareProducts.get(productId);
    this.compareProducts.delete(productId);
    this.setCompareArray(currentProducts.filter((id) => id !== productId));

    if (this.compareProducts.size > 0) {
      this.toggleCompareToast(
        `Removed the <span class="font-semibold">${productToDelete.title}</span> from compare`
      );
      this.renderProducts();
      return;
    }
    const tbody = document.getElementById("compare-product-tbody");
    if (tbody) {
      tbody.innerHTML = ' ';
    }
    const compareCloseButton = document.getElementById("close-compare-pop-up");
    compareCloseButton.click();
  }

  static toggleCompareToast(message) {
    const toast = document.getElementById("toast-compare-modal");
    const toastMessage = toast.querySelector("div.toast-compare-modal_message");
    if (!toast && !toastMessage) {
      console.error("didn't find toast components");
      return;
    }

    toastMessage.innerHTML = message;
    toast.classList.remove("opacity-0", "hidden");

    setTimeout(() => {
      toast.classList.add("opacity-0");
      toastMessage.innerHTML = ``;
    }, 3000);
  }

  static async retrieveProducts() {
    const productIds = BtCompareUtil.getCompareArray();

    if (productIds.length < 1) {
      return [];
    }
    const queryIds = productIds.map((id) => {
      const newId = `gid://shopify/Product/${id}`;
      return newId;
    });

    const query = `query{
            nodes(ids: [${queryIds.map((id) => `"${id}"`).join(",")}]) {
                ... on Product {
                    id
                    title
                    featuredImage {
                        src
                    }
                    options(first: 10) {
                        name
                    }
                    metafield(namespace: "descriptors", key: "subtitle") {
                        value
                      }
                    variants(first: 50) {
                      nodes {
                        metafield(key: "buyout_Price", namespace: "product_page") {
                          value
                        }
                        id
                        selectedOptions {
                          name
                          value
                        }
                        price{
                            amount
                        }
                        availableForSale
                      }
                    }
                    vendor
                }
            }
        }`;


    const response = await fetch(
      `https://rentoza.myshopify.com/api/2024-01/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": `${storefrontAPI}`,
        },
        body: JSON.stringify({ query }),
      }
    );

    const jsonResponse = await response.json();
    if (jsonResponse.data) {
      return jsonResponse.data.nodes;
    }
  }

  static async renderProducts() {
    const products = await this.retrieveProducts();
    const tbody = document.getElementById("compare-product-tbody");
    if (tbody) {
      tbody.innerHTML = ' ';
    }
    if (products.length < 1 ) {
      return;
    }
    products.forEach((product) => {
      const formattedId = this.formatShopifyId(product.id);
      this.compareProducts.set(formattedId, product);
    });
    
    
    this.renderProductMedia();
    this.renderVendor();
    this.attachSubPicker();
    this.renderProductColorOptions();
    this.renderVariantOptions();
    this.renderSubscribeButton();

    this.clickFirstOptions();
  }

  static renderProductMedia() {
    const tableRow = document.createElement("tr");
    
    for (const product of this.compareProducts) {
      // const formattedId = this.formatProductId(product.id);
      const newCell = document.createElement("td");
      newCell.classList = "w-[20rem]";
      const productTitle = !product[1].metafield ? product[1].title : product[1].metafield.value 
      newCell.innerHTML = `
            <div class="flex flex-col justify-between">
            <div class="flex flex-col h-full">
            <div class="product-compare-${
              product[0]
            } flex flex-col items-center justify-self-center">
            <div class="flex justify-center"><h6 class="compare-product-title font-semibold h6 line-clamp-2">${
                productTitle
              }</h6></div>
            
            <div class="h-40 w-40">
                <img srcset="${product[1].featuredImage.src}"/>
            </div>
            <button onclick="BtCompareUtil.removeCompareProduct('${this.formatShopifyId(
              product[1].id
            )}')" type="button" class="border border-solid border-[#E4E7F1] bg-[#EDF0F6] rounded shadow-md p-[0.3rem] m-2 w-10 h-10 align-bottom" >
                <svg xmlns="http://www.w3.org/2000/svg" width="{{ icon_width | default: 20 }}" height="{{ icon_width | default: 20 }}" viewBox="0 0 20 20" fill="none" focusable="false" role="presentation" class="icon icon-remove">
                    <path d="M15.8333 5.83333L15.1105 15.9521C15.0482 16.8243 14.3225 17.5 13.4481 17.5H6.55184C5.67745 17.5 4.95171 16.8243 4.88941 15.9521L4.16665 5.83333M8.33331 9.16667V14.1667M11.6666 9.16667V14.1667M12.5 5.83333V3.33333C12.5 2.8731 12.1269 2.5 11.6666 2.5H8.33331C7.87308 2.5 7.49998 2.8731 7.49998 3.33333V5.83333M3.33331 5.83333H16.6666" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="sr-only">Close modal</span>
            </button>
        </div>
            </div>
            </div>
            `;
      tableRow.appendChild(newCell);
    }
    const tbody = document.getElementById("compare-product-tbody");
    tbody.appendChild(tableRow);
  }

  static deleteCompareItem(productId) {
    const currentLocalStorageProducts = BtCompareUtil.compareProducts;

    this.compareProducts.delete(productId);
    this.setCompareArray((id) => id !== productId);
    this.renderProducts();
    // const compareProductIds = this.getCompareArray();
    // const updateArray = compareProductIds.filter((id)=>id!==productId);
    // this.setCompareArray(updateArray);
    // this.compareProducts.delete(productId);
    // // TODO - THIS IS A TEMPORARY SOLVE
    // const tbody = document.getElementById('compare-product-tbody');
    // if (tbody) {
    //     tbody.innerHTML='';
    // }
    // this.renderProductMedia();
    // this.renderVendor();
    // this.attachSubPicker();
    // this.renderProductColorOptions();
    // this.renderVariantOptions();
    // this.renderSubscribeButton();

    // this.clickFirstOptions();
  }

  static renderVendor() {
    const tableRow = document.createElement("tr");
  
    for (const product of this.compareProducts) {
      const newCell = document.createElement("td");
      newCell.classList = "w-max";
      // tableData.className=`product-compare-${product.id} flex flex-col border-none space-y-6`;
      newCell.innerHTML = `
                <div class="product-compare-${product[0]}">
                    <p class="font-semibold uppercase">Brand: <span class="font-normal normal-case">${product[1].vendor}</span></p>
                </div>
            `;
      tableRow.appendChild(newCell);
    }
    const tbody = document.getElementById("compare-product-tbody");
    tbody.appendChild(tableRow);
  }

  static renderVariantOptions() {
    const availableProductOptionsSet = new Set();
    for (const product of this.compareProducts) {
      const otherProductOptions = product[1].options.filter(
        ({ name }) => name != "Color" && name != "Subscription Term"
      );
      if (otherProductOptions < 1) {
        continue;
      }

      for (const availableOption of otherProductOptions) {
        availableProductOptionsSet.add(availableOption.name);
      }
    }

    for (const availableOption of availableProductOptionsSet) {
      const productOptionDataRow = document.createElement("tr");

      for (const product of this.compareProducts) {
        const productId = this.formatShopifyId(product[1].id);
        const newCell = document.createElement("td");
        newCell.classList = "w-max";
        const optionWrapper = document.createElement("div");
        optionWrapper.innerHTML = `
                    <p>${availableOption}:</p>
                    <div class="compare-options-${product[0]} other-option-container grid grid-cols-2 gap-2"></div>
                `;
        optionWrapper.className = "flex flex-col";

        const productHasCurrentOption = product[1].options.some(
          ({ name }) => name == availableOption
        );

        if (!productHasCurrentOption) {
          productOptionDataRow.appendChild(newCell);
          continue;
        }

        const uniqueAvailableOptions = new Set();

        for (const variant of product[1].variants.nodes) {
          const variantOptions = variant.selectedOptions.find(
            (option) => option.name == availableOption
          );
          if (!variantOptions) {
            continue;
          }

          if (uniqueAvailableOptions.has(variantOptions.value)) {
            continue;
          }
          uniqueAvailableOptions.add(variantOptions.value);
        }

        const subtermOptionWrapper = optionWrapper.querySelector(
          ".other-option-container"
        );

        for (const uniqueAvailableOption of uniqueAvailableOptions) {
          const subtermOptionInput = document.createElement("div");
          subtermOptionInput.innerHTML = `
                        <input name="${availableOption}-${productId}" data-product-id="${productId}" data-option-name="${availableOption}" value="${uniqueAvailableOption}" type="radio" class="w-0 h-0"/>
                        <label onclick="productOptionClick(this, ${productId}, '${uniqueAvailableOption}')" data-product-id="${productId}" for="${availableOption}" class="flex items-center px-2 py-3 border-solid border-2 rounded-lg justify-around">${uniqueAvailableOption}</label>
                    `;
          subtermOptionWrapper.appendChild(subtermOptionInput);
          // newCell.appendChild(subtermOptionWrapper);
        }
        newCell.appendChild(optionWrapper);
        productOptionDataRow.appendChild(newCell);
        // const firstOptionLabel=subtermOptionWrapper.querySelector('label');
        // firstOptionLabel.click();
      }
      const tbody = document.getElementById("compare-product-tbody");
      tbody.appendChild(productOptionDataRow);
    }
  }

  /**
   * Description placeholder
   * @date 19/02/2024 - 20:32:23
   *
   * @static
   * @param {string} productId
   * @returns {string}
   */
  static formatShopifyId(productId) {
    return productId.split("/").reverse()[0];
  }

  /**
   *
   *
   * @static
   * @param {Product} product
   * @return {ProductVariant[]}
   * @memberof BtCompareUtil
   */
  static filterVariantsBySubTerm(product) {
    const uniqueSubAmounts = new Set();
    const filteredVariants = product.variants.nodes.filter((variant) => {
      if (!uniqueSubAmounts.has(variant.price.amount)) {
        uniqueSubAmounts.add(variant.price.amount);
        return true;
      }
      return false;
    });

    return filteredVariants;
  }

  static attachSubPicker() {
    const tableRow = document.createElement("tr");

    for (const product of this.compareProducts) {
      const newCell = document.createElement("td");
      newCell.classList = "w-max";
      const uniqueSubterms = new Set();
      const productId = this.formatShopifyId(product[1].id);

      newCell.innerHTML = `
            <div class="w-[15rem] md:w-[23rem]">
                <h3 class="font-semibold uppercase">Subscription Terms</h3>
                <div class="flex flex-col xl:flex-row xl:mt-2 xl:items-center xl:justify-between">
                    <p class="text-sm font-medium mt-2 xl:mt-0">Select your subscription term: </p>
                    <h3 id="compare-subterm-amount-${product[0]}" class="text-shamrock-500 text-xl font-bold mt-2 xl:mt-0">
                        <span  class="compare-subterm-amount-${product[0]}">${product[1].variants.nodes[0].price.amount}</span>
                        <span class="text-cello-500 text-sm font-normal">p/m</span>
                    </h3>
                </div>
                <div id="compare-subterm-options-${product[0]}" class="compare-options-${product[0]} flex mt-3 flex-wrap">

                </div>
            </div>    
            `;

      for (const variant of product[1].variants.nodes) {
        const subtermInputWrapper = newCell.querySelector(
          `#compare-subterm-options-${product[0]}`
        );
        for (const option of variant.selectedOptions) {
          if (option.name !== "Subscription Term") {
            continue;
          }
          if (uniqueSubterms.has(option.value)) {
            continue;
          }

          uniqueSubterms.add(option.value);

          const subTermInput = document.createElement("div");
          subTermInput.className = `compare-subterm-input-${product[0]} w-10 mr-2 mb-2`;
          subTermInput.innerHTML = `
                        <input name="subterm-${productId}" data-product-id="${productId}" data-option-name="${option.name}" type="radio" value="${option.value}" class="w-0 h-0"/>
                        <label onclick="productOptionClick(this,${productId},'${option.value}')" data-product-id="${productId}" for="${option.name}" class="flex items-center px-2 py-3 border-solid border-2 rounded-lg justify-around">${option.value}</label>
                    `;

          subtermInputWrapper.appendChild(subTermInput);
        }

        // const firstOptionLabel = subtermInputWrapper.querySelector('label');
        // firstOptionLabel.click();
      }
      tableRow.appendChild(newCell);
    }

    const tbody = document.getElementById("compare-product-tbody");
    tbody.appendChild(tableRow);
  }

  static renderProductColorOptions() {
    const tableRow = document.createElement("tr");

    for (const product of this.compareProducts) {
      const productId = this.formatShopifyId(product[1].id);
      const hasColor = product[1].options.some(({ name }) => name === "Color");
      const newCell = document.createElement("td");
      newCell.classList = "w-max";

      if (!hasColor) {
        // title.classList.add('hidden')
        // const title = newCell.querySelector('p')
        tableRow.appendChild(newCell);
        continue;
      }

      newCell.innerHTML = `
                <div>
                    <p class="text-sm font-semibold mb-2">Color: </p>
                    <div id="compare-options-${product[0]}" class="compare-options-${product[0]} flex flex-wrap">
                    
                    </div>
                </div>
            `;

      // NOTE : THIS MAY NOT BE ENTIRELY NECESSARY, MAYBE REFACTOR TO HANDLE JUST THE FIRST SUBTERM
      const uniqueSubtermColors = new Map();
      for (const variant of product[1].variants.nodes) {
        if (variant.availableForSale) {
          for (const option of variant.selectedOptions) {
            if (option.name == "Subscription Term") {
              if (uniqueSubtermColors.has(option.value)) {
                continue;
              }
              uniqueSubtermColors.set(option.value, new Set());
            }

            if (option.name === "Color") {
              const variantSubterm = variant.selectedOptions.find(
                (option) => option.name === "Subscription Term"
              ).value;

              for (const [subterm, colorSet] of uniqueSubtermColors) {
                if (subterm === variantSubterm) {
                  colorSet.add(option.value);
                }
              }
            }
          }
        }
      }

      // const colorOptionsWrapper = document.createElement('div')

      const colorOptionWrapper = newCell.querySelector(
        `[id^="compare-options-${product[0]}"]`
      );

      const firstSubTermColors = uniqueSubtermColors.entries().next().value[1];
      for (const color of Array.from(firstSubTermColors)) {
        const colorInput = document.createElement("div");
        colorInput.className = "mb-2 mr-2 w-[10rem]";
        colorInput.innerHTML = `
                    <input name="color-${productId}" data-product-id="${productId}" data-option-name="Color" value="${color}" type="radio" class="w-0 h-0"/>
                    <label onclick="productOptionClick(this,${productId},'${color}')" data-product-id="${productId}"  for="Color" class="flex items-center px-2 py-3 border-solid border-2 rounded-lg justify-around">${color}</label>
                `;
        colorOptionWrapper.appendChild(colorInput);
      }

      // const firstOptionLabel = colorOptionWrapper.querySelector('label');
      // firstOptionLabel.click();
      tableRow.appendChild(newCell);
    }
    const tbody = document.getElementById("compare-product-tbody");
    tbody.appendChild(tableRow);
  }

  static renderSubscribeButton(products) {
    const tableRow = document.createElement("tr");
    for (const product of this.compareProducts) {
      const newCell = document.createElement("td");
      newCell.classList = "w-max";
      newCell.innerHTML = `
      <div class="flex flex-col justify-center items-center">
        <div class="product-compare-${product[0]} w-[15rem] md:w-[23rem]">
            <button
                onclick="addItemToCart(this)"
                data-current-selected-variant-id
                id="compare-subscribe-button-${product[0]}"
                type="button"
                class="group relative flex flex-col items-center justify-center p-0.5 mx-auto overflow-hidden text-base font-medium text-cello-500 rounded-full group hover:text-white hover:bg-cello-500 focus:ring-4 focus:outline-none focus:ring-blue-300 border-solid border-2"
            >
                <p class="relative w-full px-5 py-2.5 transition-all ease-in duration-75 bg-white rounded-full group-hover:bg-opacity-0">
                    <span class="bg-clip-text group-hover:text-white">
                        Subscribe Now
                    </span>
                </p>
            </button>
        </div>
      </div>
    `;
      tableRow.appendChild(newCell);
    }
    const buttons = tableRow.querySelectorAll('button');
        
    const tbody = document.getElementById('compare-product-tbody');
    tbody.appendChild(tableRow);

    if (buttons.length==1) {
        buttons[0].classList.replace('w-full','w-4/5');
        return;
    }
  }

  //TODO - add implementation of this function.
  //TODO - Refer to variantChange() in common.js on how to retrieve the right variant
  static addCompareProductToCart() {}

  static clickFirstOptions() {
    for (const [compareProductId, compareProduct] of this.compareProducts) {
      const productOptionWrappers = document.querySelectorAll(
        `td div.compare-options-${compareProductId}`
      );
      if (productOptionWrappers.length < 1) {
        return;
      }

      for (const optionWrapper of productOptionWrappers) {
        const firstOptionLabel = optionWrapper.querySelector(
          `label[data-product-id="${compareProductId}"]`
        );
        // if (compareProductId==='7931786494164') {
        //     console.log('Macbook');
        // }

        if (!firstOptionLabel) {
          continue;
        }
        
        firstOptionLabel.click();
      }

      //
      // console.log('found option label', productOptionWrappers)
    }
  }

  // Updates the UI element showing the number of products for comparison
  static updateCompareBubble(ignoreZero = false) {
    // const total = this.getCompareArray().length;
    // if (total > 0 || !ignoreZero) {
    //     document.querySelectorAll(this.bubbleHtmlClass)
    //         .forEach(bubble => bubble.textContent = total);
    // }
  }

  // Shows a popup message when the comparison array is full
  static showFullPopup() {
    // const comparePopUp = document.querySelector("compare-popup");
    // if (comparePopUp) {
    //     comparePopUp.classList.add("full");
    //     setTimeout(() => comparePopUp.classList.remove("full"), 5000);
    // }
  }

  // Displays a message if a product is already added to the comparison array
  static showProductAlreadyAddedMessage() {
    // Implement the logic for showing a duplicate product message
  }

  // Toggles warning or empty classes on the compare popup based on the number of compared items
  static toggleEmptyWarning(popup) {
    // const size = this.getCompareArray().length;
    // if (size > 1) {
    //     popup.classList.remove("empty", "warning");
    // } else if (size === 1) {
    //     popup.classList.remove("empty");
    //     popup.classList.add("warning");
    //     setTimeout(() => popup.classList.remove("warning"), 3000);
    // } else {
    //     popup.classList.add("empty");
    //     setTimeout(() => popup.classList.remove("empty"), 3000);
    // }
  }
}
BtCompareUtil.init();

let debounceTimer;
function debounce(func,delay){
    clearTimeout(debounceTimer);
    debounceTimer =setTimeout(func,delay);
}

function searchCompare(searchInput){
    const searchQuery = searchInput.value;

    if (searchQuery.trim().length<1) {
        return;
    }
    fetch(`${window.Shopify.routes.root}search/suggest.json?q=
        ${searchQuery}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type`)
        .then((response)=>response.json())
        .then(({resources})=>{
            const {products} = resources.results;
            if (products.length<1) {
                return;
            }

            const searchResultsList = document.getElementById('compare-predictive-search-results');
            if (!searchResultsList) {
                return;
            }
            const searchResultsContainer = document.getElementById('search-results-container');
            searchResultsContainer.classList.remove('hidden');
            
            searchResultsList.innerHTML='';

            for (const product of products) {
                const {id, image, title} = product;
              

                const listItem = document.createElement('li');
                listItem.className='hover:bg-shamrock-500 hover:text-white px-1 p-2';
                listItem.innerHTML =`
                    <div data-prodyct-id="${id}" class="flex mx-4 items-center">
                        <div class="w-10 h-8 space-x-4"><img src="${image}" class="w-full h-full"/></div>
                        <div class="truncate line-clamp-1">${title}</div>
                    </div>`;
                searchResultsList.appendChild(listItem);

                listItem.onclick = ()=>{

                    const compareItems = BtCompareUtil.getCompareArray();
                    if (compareItems.length==2) {
                        BtCompareUtil.toggleCompareToast(`The compare list is full. please remove an item.`);
                        hideSearchResults();
                        return;
                    }
                    
                    if (compareItems.some(item=>item===`${id}`)) {
                        BtCompareUtil.toggleCompareToast(`The <span class="font-semibold">${title}</span> is already in the compare list. \ntry adding another item`);
                        hideSearchResults();
                        return;
                    }

                    BtCompareUtil.toggleProductIntoCompare(`${id}`);
                    hideSearchResults();
                    
                };

            }
        });
}

function hideSearchResults(){
    const searchResultsContainer = document.getElementById('search-results-container');
    if (!searchResultsContainer) {
        return;
    }
    searchResultsContainer.classList.add('hidden');
}


/**
 * Description placeholder
 * @date 18/02/2024 - 15:58:53
 *
 * @param {HTMLLabelElement} labelElement
 * @param {string} productId
 */
function productOptionClick(labelElement, productId,optionValue) {
  const selectedVariantOptions = new Map();
  
  const productOptionInputs = document.querySelectorAll(`td input[data-product-id="${productId}"]`);
  
  const productOptionNames = new Set()
  for (const productOptionInput of productOptionInputs) {
    if (!productOptionNames.has(productOptionInput.dataset.optionName)) {
      productOptionNames.add(productOptionInput.dataset.optionName);
    }
  }

  const productOptionInputsArray = Array.from(productOptionInputs);

  const clickedOptionInput =document.querySelector(`input[data-product-id="${productId}"][value="${optionValue}"]`);

  // console.log('clicked option input',clickedOptionInput);
  
  for (const productOptionName of productOptionNames) {
    const currentlyCheckedOptionInput = productOptionInputsArray
    .filter(optionInput=>optionInput.dataset.optionName===productOptionName)
    .find(foundInput=>foundInput.checked===true);

    if (clickedOptionInput && clickedOptionInput.dataset.optionName === productOptionName ) {
      

      if (currentlyCheckedOptionInput) {
        // console.log('there is currently...',currentlyCheckedOptionInput);
        currentlyCheckedOptionInput.click();
      }

      clickedOptionInput.click();
      continue;
    }

    // console.log(currentlyCheckedOptionInput);
    if (currentlyCheckedOptionInput) {
      
      continue;
    }
    
    productOptionInputsArray
    .filter(optionInput=>optionInput.dataset.optionName===productOptionName)[0]
    .checked=true;  
  }

  // console.log('eyy', productOptionInputsArray.filter(productOptionInput=> productOptionInput.checked==true));
  const checkedOptionInputs = productOptionInputsArray.filter(productOptionInput=> productOptionInput.checked==true);
  if (!checkedOptionInputs) {
    return;
  }

  for (const checkedOptionInput of checkedOptionInputs) {
    const value = checkedOptionInput.value;
    const name = checkedOptionInput.dataset.optionName;

    selectedVariantOptions.set(`${name}:${value}`, true);
    // const siblingLabel = Array.from(document.querySelectorAll(`label[data-product-id="${productId}"][for="${checkedOptionInput.dataset.optionName}"]:contains("${checkedOptionInput.value}")`))
    const optionLabels = Array.from(document.querySelectorAll(`label[data-product-id="${productId}"][for="${checkedOptionInput.dataset.optionName}"]`));

    optionLabels.forEach(optionLabel=>{
      optionLabel.className = "flex items-center px-2 py-3 border-solid border-2 rounded-lg justify-around";
      if (optionLabel.textContent == checkedOptionInput.value) {
        optionLabel.className = "flex items-center px-2 py-3 border-solid border-cello-100 bg-cello-50 border-2 rounded-lg justify-around shadow";        
      }
    })
  }
  updateCompareProductVariant(productId.toString(), selectedVariantOptions);
}

/**
 * Description placeholder
 * @date 20/02/2024 - 11:22:34
 *
 * @param {string} productId
 * @param {Map} selectedOptionsMap
 */
function updateCompareProductVariant(productId, selectedOptionsMap) {
  const productToUpdate = BtCompareUtil.compareProducts.get(productId);

  if (!productToUpdate) {
    return;
  }

  /**
   * @type {Array}
   */
  const variants = productToUpdate.variants.nodes;
  let variantFound;

  for (const variant of variants) {
    const variantOptionMap = new Map(
      variant.selectedOptions.map((option) => [
        `${option.name}:${option.value}`,
        true,
      ])
    );

    let isMatch = true;
    for (const [key] of variantOptionMap) {
      if (!selectedOptionsMap.has(key)) {
        isMatch = false;
        break;
      }
    }

    if (isMatch) {
      variantFound = variant;
    }
  }

  if (!variantFound) {
    return;
  }


  const subscribeButton = document.querySelector(
    `button#compare-subscribe-button-${productId}`
  );
  updateCompareProductPrice(productId, variantFound);
  subscribeButton.dataset.currentSelectedVariantId =
    BtCompareUtil.formatShopifyId(variantFound.id);
}

function updateCompareProductPrice(productId, newSelectedVariant) {
  const compareSubtermAmountSpan = document.querySelector(
    `span.compare-subterm-amount-${productId}`
  );
  if (!compareSubtermAmountSpan) {
    return;
  }
  compareSubtermAmountSpan.innerHTML = convertToMoney(
    newSelectedVariant.price.amount
  );
}

async function addItemToCart(compareButton) {
  const variantId = compareButton.dataset.currentSelectedVariantId;

  if (!variantId) {
    return;
  }
  let formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };

  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });

  if (response) {
    const productTitle = await response.items[0].product_title;
    BtCompareUtil.toggleCompareToast(
      `successfully added <span class="font-semibold">${productTitle}</span> to cart.`
    );
  }
}

class ComparePopup extends HTMLElement {
  constructor() {
    super();
    this.assets = document.getElementById("compare-modal-assets");
    this.results = this.querySelector(".compare-modal__results");
    this.hasAssets = false;
  }

  // Loads content for the compare popup
  loadContent() {
    // Prevent reloading if content is already loaded
    if (BtCompareUtil.loadedContent) return;

    this.classList.add("loading");
    const currentProducts = BtCompareUtil.getCompareArray();
    const newIds = currentProducts.map((productId) => `id:${productId}`);
    const idsQuery = newIds.join(" OR ");

    // Fetch and display product data for comparison
    fetch(
      `${window.routes.search_url}?section_id=product-compare&q=${idsQuery}&type=product`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        // Populate assets and results only if not already done
        if (!this.hasAssets) {
          this.assets.innerHTML = html.querySelector(".assets").innerHTML;
          this.hasAssets = true;
        }
        this.results.innerHTML = html.querySelector(".results").innerHTML;
        updateCompareColorSwatchAndName(); // Update UI elements
        BtCompareUtil.toggleEmptyWarningClass(this);
      })
      .finally(() => {
        this.classList.remove("loading");
        BtCompareUtil.loadedContent = true;
      });
  }
}
customElements.define("compare-popup", ComparePopup);

class CompareAddButton extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  // Binds the click event to the button
  bindEvents() {
    this.button = this.querySelector("button");
    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.button.addEventListener("click", this.onButtonClickHandler);
  }

  // Removes event listeners when the element is disconnected
  disconnectedCallback() {
    this.button.removeEventListener("click", this.onButtonClickHandler);
  }

  // Handler for the button click event
  onButtonClick() {
    const productId = this.button.dataset.productId;
    BtCompareUtil.toggleProductIntoCompare(productId);
  }
}
customElements.define("compare-add-button", CompareAddButton);

class SearchResultCompareAddButton extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  // Binds the click event to the button
  bindEvents() {
    this.button = this.appendChild(document.createElement("button"));
    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.button.addEventListener("click", this.onButtonClickHandler);
  }

  // Removes event listeners when the element is disconnected
  disconnectedCallback() {
    this.button.removeEventListener("click", this.onButtonClickHandler);
  }

  // Handler for the button click event
  onButtonClick() {
    const productId = this.dataset.productId;
    BtCompareUtil.toggleProductIntoCompare(productId);
    const comparePopup = document.querySelector("compare-popup");
    if (comparePopup) {
      comparePopup.loadContent();
    }
  }
}
customElements.define(
  "search-result-compare-add-button",
  SearchResultCompareAddButton
);

class InitializeCompareButton extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  // Binds events to the button
  bindEvents() {
    this.button = this.querySelector("button");
    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.button.addEventListener("click", this.onButtonClickHandler);
  }

  // Handler for the button click event
  onButtonClick() {
    const productId = this.button.dataset.productId;
    BtCompareUtil.toggleProductIntoCompare(productId);
    const compareModal = document.querySelector("modal-opener");
    if (compareModal) {
      compareModal.dataset.modal = "#Compare-Modal";
      const modalOpenerButton = compareModal.querySelector("button");
      modalOpenerButton.dataset.productId = productId;
      modalOpenerButton.click();
    }
  }

  // Removes event listeners when the element is disconnected
  disconnectedCallback() {
    this.button.removeEventListener("click", this.onButtonClickHandler);
  }
}
customElements.define("start-compare-button", InitializeCompareButton);

class CompareRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  // Binds the click event to the remove button
  bindEvents() {
    this.button = this.querySelector("a");
    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.button.addEventListener("click", this.onButtonClickHandler);
  }

  // Handler for the remove button click event
  onButtonClick(e) {
    e.preventDefault();
    const productId = this.button.dataset.productId;
    BtCompareUtil.removeCompareProduct(productId);
    const popup = this.closest("compare-popup");
    if (popup) {
      BtCompareUtil.toggleEmptyWarningClass(popup);
      popup
        .querySelectorAll(`.product-compare-${productId}`)
        .forEach((td) => td.remove());
    }
  }

  // Removes event listeners when the element is disconnected
  disconnectedCallback() {
    this.button.removeEventListener("click", this.onButtonClickHandler);
  }
}
customElements.define("compare-remove-button", CompareRemoveButton);

// class CompareVariantRadios extends VariantRadios {
//     constructor() {
//         super();
//         this.isRadios = this.localName === "compare-variant-radios";
//         this.dataset.originalSection = "product-compare-item";
//         this.customSectionId = this.closest("div").dataset.customSectionId;
//     }

//     // Handles the variant change event
//     onVariantChange(event) {
//         this.updateOptions();
//         this.updateMasterId();
//         this.toggleAddButton(true, "", false);
//         this.removeErrorMessage();
//         this.updateVariantStatuses();
//         this.updateSoldoutValues();

//         if (!this.currentVariant) {
//             this.toggleAddButton(true, "", true);
//             this.setUnavailable();
//         } else {
//             this.updateVariantInput();
//             this.renderProductInfo();
//         }

//         if (this.isRadios && this.currentVariant) {
//             this.updateOptionLabel(event);
//         }
//     }

//     // Renders the product information based on the selected variant
//     renderProductInfo() {
//         // Fetch and update UI for the selected variant
//         fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection || this.dataset.section}`)
//             .then(response => response.text())
//             .then(responseText => {
//                 const html = new DOMParser().parseFromString(responseText, "text/html");
//                 this.updateElements(html);
//                 const price = document.getElementById(`price-${this.customSectionId}`);
//                 if (price) price.classList.remove("visibility-hidden");
//                 this.toggleAddButton(!this.currentVariant || !this.currentVariant.available, window.variantStrings.soldOut);
//             });
//     }

//     // Updates various elements of the product display
//     updateElements(html) {
//         const elementKeys = ["featured-image", "price", "inventory"];
//         elementKeys.forEach(key => {
//             const destination = document.getElementById(`${key}-${this.customSectionId}`);
//             const source = html.getElementById(`product-compare-${key}`);
//             if (source && destination) destination.innerHTML = source.innerHTML;
//         });
//     }

// }
// customElements.define("compare-variant-radios", CompareVariantRadios);

// class CompareVariantSelects extends CompareVariantRadios {
//     constructor() {
//         super();
//     }

//     // Update the options based on the select element values
//     updateOptions() {
//         this.options = Array.from(this.querySelectorAll("select"), select => select.value);
//     }
// }
// customElements.define("compare-variant-selects", CompareVariantSelects);
